<template>
  <div class="p-3 bg-[#2a2a2b] rounded-lg border border-[#515154] shadow-lg w-80">
    <div class="text-xs text-[#9d9d9d] mb-2 font-medium">
      {{ t('score_tooltip.title') }}
    </div>
    <ul class="space-y-2">
      <li v-for="(item, idx) in explanationItems" :key="idx" class="flex items-start gap-2">
        <Icon :name="item.icon" class="size-4 shrink-0 mt-0.5" :class="item.iconClass" />
        <span class="text-xs text-white/90 leading-relaxed">{{ item.description }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import type { ScoreBreakdown } from '~/api/v2/experts/ExpertRepository';
import { useScoreExplanation } from '~/composables/useScoreExplanation';

const { t } = useI18n();

const props = defineProps<{
  breakdown: ScoreBreakdown;
  matchScore: number;
}>();

const { explanationItems } = useScoreExplanation(
  toRef(props, 'breakdown'),
  toRef(props, 'matchScore'),
);
</script>
